import React, { useState, useContext, useEffect } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { Modal } from '@carvana/showroom-modal';
import { eventableTypes } from './constants';
import { LoadingSpinner } from '../components';
import ASRImageSelector from './components/ASRImageSelector';
import ASRDisclaimer from './components/ASRDisclaimer';
import CosmeticConfirmation from './components/CosmeticConfirmation';
import MechanicalSubmission from './components/MechanicalSubmission';
import ASRCreateDetails from './components/ASRCreateDetails';
import ErrorBoundary from './components/ErrorBoundary';
import { RouterProvider, Route, ROUTES } from '../providers/router';
import { CreateAsrProvider } from '../providers/create-asr';

type ReportConcernModalProps = {
  onModalCloseCallback?: () => void;
  reportedConcerns?: any[];
};

const ReportConcernModal = ({
  onModalCloseCallback = () => {},
  reportedConcerns = [],
}: ReportConcernModalProps) => {
  const [modalOpen, setModalOpen] = useState(true);
  const { trackEvent } = useContext(AnalyticsContext);

  const closeModalReset = () => {
    setModalOpen(false);
    onModalCloseCallback();
  };

  useEffect(() => {
    const existingStorageValue = sessionStorage.getItem('cvTestStorage');
    console.log('existing storage:', existingStorageValue);

    sessionStorage.setItem('cvTestStorage', 'testValue');
  }, []);

  return (
    <div>
      <ErrorBoundary>
        {modalOpen && (
          <Modal
            headerText="Report Vehicle Issue"
            isOpen={modalOpen}
            closeModal={() => {
              trackEvent(eventableTypes.modalClosed);
              closeModalReset();
            }}
          >
            <RouterProvider>
              <CreateAsrProvider>
                <Route path={ROUTES.ASR_FORM} component={<ASRCreateDetails />} />
                <Route path={ROUTES.COSMETIC_DISCLAIMER} component={<ASRDisclaimer reportedConcerns={reportedConcerns} closeModal={closeModalReset} />} />
                <Route path={ROUTES.COSMETIC_IMAGES} component={<ASRImageSelector/>} />
                <Route path={ROUTES.COSMETIC_SUCCESS} component={<CosmeticConfirmation closeModal={closeModalReset} />} />
                <Route path={ROUTES.MECHANIC_SUCCESS} component={<MechanicalSubmission />} />

                <Route path={ROUTES.LOADING} component={<LoadingSpinner />} />
              </CreateAsrProvider>
            </RouterProvider>
          </Modal>
        )}
      </ErrorBoundary>
    </div>
  );
};

export default ReportConcernModal;
